// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"content_wrapper__8XJuk","hidden":"content_hidden__9mkJa"};